<template>
	<section>
		<div v-if="showParentView('page-project')">
			<header-page
				name="projects"
				:title="$route.meta.title"
			/>
			<project-list
				:columns="columns"
				:current-page="currentPage"
				:rows="table.rows"
				:last-page="table.lastPage"
				@change-page="changePage"
				@on-delete="loadData('projects')"
				@on-search="onSearch($event, 'projects')"
			/>
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import projectList from '@/components/projects/project-list';

function created() {
	if (this.$route.name === 'page-project') {
		this.loadData('projects');
	}
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.loadData('projects');
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'CP',
				text: 'Crear Proyecto',
				img: 'https://goo.su/QXdqe',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Id', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'Código', checked: true, visible: true },
			{ id: 4, name: 'Descripción', checked: true, visible: true },
			{ id: 5, name: 'Acciones', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
	};
}

function openModal() {
	this.goTo('page-project-new');
}

export default {
	name: 'page-project',
	created,
	components: {
		projectList,
		quickActions,
	},
	data,
	methods: {
		changePage,
		openModal,
	},
	watch: {
		$route(newVal) {
			if (newVal) {
				if (newVal.name === 'page-project') {
					this.loadData('projects');
				}
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/projects/page-project.vue